import {MyHospitalizationFlowEnum} from 'presentation/constants';
import {translations} from 'presentation/translations-new';
import {ShortcutMyHospitalizationType} from './types';

const {
	generalOrientations,
	doctorVisits,
	exams,
	informations,
	opinions,
	patientData,
	prescriptions,
	procedures,
} = translations['pt-br'].privateFlow.myHospitalization.home.cards;

export const SHORTCUTS_MY_HOSPITALIZATION_LIST: ShortcutMyHospitalizationType[] = [
	{
		title: generalOrientations,
		icon: 'info-outlined',
		route: MyHospitalizationFlowEnum.GENERAL_ORIENTATIONS,
		isInverseColor: true,
		dataTestId: 'general-orientations-button',
	},
	{
		title: patientData,
		icon: 'person-outline',
		route: MyHospitalizationFlowEnum.PATIENT_DATA,
		dataTestId: 'patient-data-button',
	},
	{
		title: informations,
		icon: 'assignment-outline',
		route: MyHospitalizationFlowEnum.INFORMATION,
		dataTestId: 'information-button',
	},
	{
		title: opinions,
		icon: 'text-box-outline',
		route: MyHospitalizationFlowEnum.OPINIONS,
		dataTestId: 'opinions-button',
	},
	{
		title: procedures,
		icon: 'clipboard-pulse-outline',
		route: MyHospitalizationFlowEnum.PROCEDURES,
		dataTestId: 'procedures-button',
	},
	{
		title: exams,
		icon: 'clipboard-plus-outline',
		route: MyHospitalizationFlowEnum.EXAMS,
		dataTestId: 'exams-button',
	},
	{
		title: prescriptions,
		icon: 'needle',
		route: MyHospitalizationFlowEnum.PRESCRIPTIONS,
		dataTestId: 'prescriptions-button',
	},
	{
		title: doctorVisits,
		icon: 'stethoscope',
		route: MyHospitalizationFlowEnum.DOCTOR_VISITS,
		dataTestId: 'doctor-visits-button',
	},
];
